module.exports = __webpack_public_path__ + "img/img_mobile_select_an.ece6c95c.png";